import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  HostListener,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '@aihub/core/authorization';
import { environment } from '@environments/environment';
import { AskGenAiService } from '../../services/askGenAi.service';
import { Message } from '../../types/types';
import { appMeta } from '../../interfaces/appMeta';

@Component({
  selector: 'app-chat-thread',
  templateUrl: './chat-thread.component.html',
  styleUrls: ['./chat-thread.component.css'],
})
export class ChatThreadComponent implements OnInit, OnDestroy {
  @Input() subscription_id: string = '';
  isLoading = false;
  waitingMessage = false;
  showConversation = false;
  showDefault = false;
  showChatArea = true;
  environment = environment;
  response;
  request: string;
  jwt = '';
  streamSubscription: Subscription | undefined = undefined;
  messages: Message[] = [];
  loadChatOnQueryChange = true;
  conversation_id = '';
  isDestroyed: boolean = false;
  appMeta: appMeta;

  constructor(
    private readonly loginService: AuthService,
    private changeDetectorRef: ChangeDetectorRef,
    private askGenAi: AskGenAiService,
  ) {}

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    console.log('unloadNotification', $event);
  }

  ngOnInit() {
    this.appMeta = {
      componentType: this.environment.assetTitle,
      subscriptionId: this.subscription_id,
      stage: 'output',
    };
    if ((environment as any).products['kbin']) {
      this.showConversation = true;
      this.showChatArea = false;
    }
    this.getJwt();
  }

  getJwt() {
    this.loginService.getJwtToken().subscribe((jwt: string) => {
      this.jwt = jwt;
    });
  }

  displayResponse(prompt: any): void {
    this.showDefault = true;
    this.request = prompt;
    this.response = '';

    if (typeof prompt === 'object') {
      this.callPalmWithParams(
        prompt.promptString,
        prompt.model,
        prompt.modelParams,
      );
    }
  }

  clearResponse(response: any): void {
    this.response = response;
    this.showDefault = true;
  }

  callPalmWithParams(
    prompt: string,
    model: string = 'text-bison',
    params: any,
  ): void {
    this.waitingMessage = true;
    this.askGenAi
      .askGenAi(this.subscription_id, prompt, undefined, model, params)
      .subscribe((data) => {
        if (data.model_responses[0]) {
          this.showDefault = false;
          this.waitingMessage = false;
          this.changeDetectorRef.detectChanges();
          this.response = data.model_responses[0];
        }
      });
  }

  sendEmail() {
    let subject = 'Feedback for ' + environment.assetTitle;
    let body = 'Hi there, ';
    let mailtoLink =
      'mailto:campfire@deloitte.de?subject=' +
      encodeURIComponent(subject) +
      '&body=' +
      encodeURIComponent(body);
    window.location.href = mailtoLink;
  }

  stopLoading(): void {
    this.isLoading = false;
  }

  ngOnDestroy(): void {
    this.isDestroyed = true;
  }
}
